module.exports = "<div class=\"pg-groupheader pg-columnheader pg-columnheader-{{:groupName}}\"> <span>{{:groupTitle}}</span> </div> ";